import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box, Card, Text, token, Paragraph } from "@zillow/constellation";
import { useFormContext } from "react-hook-form";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
import { useLastValidFormValues } from "./LoanComparison.utils.esm.js";
const OUTPUTS = [{
  label: "Monthly payment",
  accessor: "monthlyPayment"
}, {
  label: "Total principal",
  accessor: "totalPrincipal"
}, {
  label: "Total interest",
  accessor: "totalInterest"
}, {
  label: "Pay-off date",
  accessor: "payOffDate"
}];
const LoanComparisonResultCard = (props) => {
  return /* @__PURE__ */ jsxs(
    Box,
    {
      as: Card,
      sx: {
        flex: 1
      },
      cardType: "secondary",
      cardElevation: 0,
      children: [
        /* @__PURE__ */ jsx(Text, { fontType: "h4", as: "p", textAlign: "center", paddingBottom: "md", children: props.headingText }),
        /* @__PURE__ */ jsx(Box, { sx: {
          backgroundColor: "$colors.coolGray100",
          paddingRight: "$spacing.sm",
          paddingLeft: "$spacing.sm",
          borderRadius: `${token("radii.sm")}`
        }, children: OUTPUTS.map(({
          label,
          accessor
        }, index) => {
          const isLastOutput = index !== OUTPUTS.length - 1;
          return /* @__PURE__ */ jsxs(Box, { sx: {
            alignItems: "center",
            justifyContent: "space-between",
            display: "flex",
            paddingBottom: "$spacing.sm",
            paddingTop: "$spacing.sm",
            borderBottom: isLastOutput ? `2px solid $colors.borderLight` : null
          }, children: [
            /* @__PURE__ */ jsx(Paragraph, { children: label }),
            /* @__PURE__ */ jsx(Text, { fontType: "h4", paddingLeft: "sm", textAlign: "right", children: getWholeDollars(props.lastValidValues[props.loanType][accessor]) })
          ] }, accessor);
        }) })
      ]
    }
  );
};
const LoanComparisonResultForm = () => {
  const form = useFormContext();
  const lastValidValues = useLastValidFormValues(form);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(LoanComparisonResultCard, { loanType: "typeOneCalculations", headingText: "Loan 1", lastValidValues }),
    /* @__PURE__ */ jsx(LoanComparisonResultCard, { loanType: "typeTwoCalculations", headingText: "Loan 2", lastValidValues }),
    /* @__PURE__ */ jsx(LoanComparisonResultCard, { loanType: "typeThreeCalculations", headingText: "Loan 3", lastValidValues })
  ] });
};
export {
  LoanComparisonResultCard,
  LoanComparisonResultForm as default
};
